
import { Options, Vue } from "vue-class-component";

@Options({
  methods: {
    requestHint() {
      this.$store.dispatch("sendMessage", "Suggerimento");
    },
  },
})
export default class HintButton extends Vue {}
